module.exports = __webpack_public_path__ + "img/one_3.6a413625.png";